const colors = {
  black: '#000',
  black700: '#000000de',

  blue100: '#f3f6f8',
  blue200: '#537b98',
  blue300: '#37a7db',
  blue500: '#0091ae',
  blue600: '#2976d2',
  blue650: '#2d79ff',
  blue800: '#046693',
  blue900: '#172b4d',

  darkBlue400: '#393f4d',
  darkBlue500: '#2d323e',

  gray150: '#fafafa',
  gray180: '#f1f1f1',
  gray190: '#f5f5f5',
  gray200: '#f0f0f0',
  gray210: '#e2e2e2',
  gray220: '#dfe1e6',
  gray230: '#d8d8d8',
  gray240: '#cccaca',
  gray250: '#d9d9d9',
  gray270: '#ebebeb',
  gray280: '#bfbdbd',
  gray290: '#e0e0e0',
  gray300: '#a7a7a7',
  gray320: '#979797',
  gray350: '#bebebe',
  gray380: '#6d6d6d',
  gray400: '#747474',
  gray450: '#696969',
  gray850: '#63666d',
  gray900: '#4d4d4d',
  gray950: '#43495b',

  green300: '#4dd472',
  green500: '#30b33a',
  green600: '#009688',

  orange300: '#f7a003',

  purple100: '#e5e9f4',
  purple270: '#d8cde4',
  purple300: '#a288c0',
  purple400: '#9575cd',
  purple450: '#584584',
  purple500: '#5e35b1',
  purple800: '#41257b',

  red200: '#f57b74',
  red300: '#f44336',
  red500: '#f50057',
  red800: '#ab003c',

  white: '#f7f7f7',
  white100: '#fff',

  yellow200: '#f1e857'
}

export default colors
